/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

function DefaultNavbarLink({ icon, name, route, light }) {
    return (
        <ArgonBox
            component={Link}
            to={route}
            mx={1}
            p={1}
            display="flex"
            alignItems="center"
            sx={{ cursor: "pointer", userSelect: "none" }}
        >
            <Icon
                sx={{
                    color: ({ palette: { white, secondary } }) => (light ? white.main : secondary.main),
                    verticalAlign: "middle",
                }}
            >
                {icon}
            </Icon>
            <ArgonTypography
                variant="button"
                fontWeight="regular"
                color={light ? "white" : "dark"}
                textTransform="capitalize"
                sx={{ width: "100%", lineHeight: 0 }}
            >
                &nbsp;{name}
            </ArgonTypography>
        </ArgonBox>
    );
}

// Typechecking props for the DefaultNavbarLink
DefaultNavbarLink.propTypes = {
    icon: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    light: PropTypes.bool.isRequired,
};

export default DefaultNavbarLink;
